import EngineeringIndex from '@/views/engineering/index';
import EngineeringDetail from '@/views/engineering/detail';
import CommonMain from '@/views/commonMain';

export default {
  path: '/engineering',
  component: CommonMain,
  redirect: '/engineering/home',
  children: [
    {
      name: '工程面板首页',
      meta: { title: '工程面板' },
      path: 'home',
      component: EngineeringIndex,
    },
    {
      name: 'detail',
      meta: { title: '工程面板' },
      path: 'detail/:id/:name',
      component: EngineeringDetail,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/engineering.js